var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8239 14.0002L23.7583 20L29.8239 25.9997C29.9335 25.7715 30.0001 25.5193 30.0001 25.25V14.75C30.0001 14.4806 29.9335 14.2284 29.8239 14.0002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2423 13H11.758C11.4874 13 11.2341 13.0662 11.0049 13.1754L18.7573 20.8545C19.4428 21.5369 20.5575 21.5369 21.243 20.8545L28.9954 13.1754C28.7663 13.0662 28.5129 13 28.2423 13Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1762 14.0002C10.0665 14.2284 10 14.4806 10 14.75V25.25C10 25.5193 10.0665 25.7716 10.1762 25.9997L16.2418 20L10.1762 14.0002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9298 20.8249L22.0715 21.6794C20.9294 22.8164 19.0709 22.8164 17.9288 21.6794L17.0705 20.8249L11.0049 26.8246C11.2341 26.9338 11.4874 27 11.758 27H28.2423C28.5129 27 28.7663 26.9338 28.9954 26.8246L22.9298 20.8249Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.fe6b31ad249b23bc39e7dcfa54d19727.svg";
export { ForwardRef as ReactComponent };